import Diamond from '@/icons/diamond';
import Spacer from '@/common/components/spacer';
import Twinkle from '@/icons/twinkle';

import { colors } from '@/theme/colors';
import { cn } from '@/shadcn-ui/utils';

export type GradientVariant = 'primary' | 'sub';

export interface NewVehiclePillProps {
  PRISTINE_HERO_PDP?: boolean;
  withoutShadow?: boolean;
}

export default function NewVehiclePill({
  PRISTINE_HERO_PDP,
  withoutShadow = false,
}: NewVehiclePillProps) {
  return PRISTINE_HERO_PDP ? (
    <div
      className={cn(
        'flex flex-shrink-0 items-center justify-center gap-[4px] rounded-[32px] bg-[linear-gradient(90deg,_#E900EC_-113.02%,_#2A00A5_99.76%)] py-[4px] pl-[8px] pr-[12px] md:py-[8px] md:pl-[12px]',
        {
          'shadow-none': withoutShadow,
          'shadow-pillShadow': !withoutShadow,
        }
      )}
    >
      <Twinkle className="h-[16px] w-[16px] flex-shrink-0 md:h-[20px] md:w-[20px]" />
      <p className="body3-tight text-[12px] font-semibold leading-[18px] text-flexcar-neutral100 md:text-[14px] md:leading-[20px]">
        Brand new
      </p>
    </div>
  ) : (
    <div
      className={cn(
        'flex flex-shrink-0 items-center justify-center rounded-[100px] px-[8px] py-[4px] backdrop-blur-[2px]',
        {
          'shadow-none': withoutShadow,
          'shadow-pillShadow': !withoutShadow,
        }
      )}
      style={{
        background: `linear-gradient(90deg, ${colors.gradientPillPrimary} 0%, ${colors.blue40} 100%)`,
      }}
    >
      <Diamond size={{ width: 14, height: 14 }} />
      <Spacer variant="width4" />
      <p className="line-height-[14px] body3-strong text-flexcar-neutral100">Brand new</p>
    </div>
  );
}
